// extracted by mini-css-extract-plugin
export default {"user":"Meals_user__1L+iR","logoutButton":"Meals_logoutButton__jttL7"};